/**
 * @file Full screen loading component for usage with Loadable components.
 */

import React from 'react';
import PropTypes from 'prop-types';

import FullScreenLoader from '../FullScreenLoader';
import Alert from '../Alert';

const propTypes = {
  pastDelay: PropTypes.bool,
  timedOut: PropTypes.bool,
};

const LoadableFullScreenLoader = ({ pastDelay, timedOut }) => {
  if (timedOut) {
    return (
      <Alert type="warning" className="text-center m-5">
        This page is taking too long to load. You might want to refresh your
        browser and try again.
      </Alert>
    );
  }

  if (pastDelay) {
    return <FullScreenLoader />;
  }

  return null;
};

LoadableFullScreenLoader.propTypes = propTypes;

export default LoadableFullScreenLoader;
